export const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/d9b67bb3-e7d0-4c69-ae20-98aaa401b970/images/b18cae97e450b8f22b992b1e5cf1db7492ef4f09d42ba69479800ad726e5d84a.png";
export const PROCESS_IMG =
  "https://static.prod-images.emergentagent.com/jobs/d9b67bb3-e7d0-4c69-ae20-98aaa401b970/images/e55fc622e774b457f1dd8a9687511f35a41e920dbbfe27fdc4c75f3bd0c8b4bc.png";

export const SEGMENTS = {
  "fintech-lenders": {
    slug: "fintech-lenders",
    nav: "Fintech & Lenders",
    icon: "Landmark",
    hook: "Expand borrower eligibility and lift funded-loan rates.",
    headline: "Remove Tax Debt as a Barrier to Customer Success",
    body: "Tax debt surfaces at the worst possible moment — mid-underwriting, during a refinance, at a major financial decision. Give customers a clear path to resolution and you turn a dead end into funded loans, deeper engagement, and a new revenue line.",
    benefits: [
      "Create a new, incremental revenue stream from your existing customer base",
      "Expand borrower eligibility and lift funded-loan rates by clearing IRS-related barriers that block qualification",
      "Re-engage previously declined borrowers across lending and refinance products",
      "Reduce fallout during underwriting and closing",
      "Boost in-app retention and engagement by offering a path forward instead of a dead end",
      "Deliver a more complete financial solution and grow customer lifetime value",
    ],
    idealFor: [
      "Fintech lending platforms",
      "Banks & credit unions",
      "Mortgage lenders & brokers",
      "Financial wellness platforms",
      "Credit-building platforms",
      "Home equity & refinance lenders",
      "Lending marketplaces",
      "Neobanks & digital banks",
    ],
    without: [
      "Qualified applicants are declined over unresolved tax debt",
      "Loans fall out of the pipeline late in underwriting",
      "Acquisition spend is wasted on lost applicants",
      "Conversion and platform engagement decline",
      "Customers turn to competitors to resolve the blocker",
      "Lending, refinance, and cross-sell opportunities are missed",
    ],
    closing:
      "Community Tax integrates as an embedded service, so you guide customers forward — rather than sending them elsewhere.",
  },
  "tax-software": {
    slug: "tax-software",
    nav: "Tax Software Providers",
    icon: "MonitorSmartphone",
    hook: "Unlock a new revenue stream from your existing client base.",
    headline: "Turn Unresolved Tax Debt Into a Retention and Revenue Opportunity",
    body: "Extend value beyond the return. When a filer hits a balance due, embed tax debt representation directly into the workflow and capture revenue that currently walks out the door.",
    benefits: [
      "Unlock a new revenue stream from your existing client base",
      "Increase ERO and preparer retention and engagement on your platform",
      "Embed representation directly into the filing workflow",
      "Keep the client relationship with the preparer, beyond the return",
      "Increase product stickiness by extending value past filing season",
    ],
    idealFor: [
      "Professional tax-prep software",
      "DIY / consumer filing software",
      "ERO and service-bureau networks",
      "Bookkeeping & accounting platforms",
      "Payroll & small-business finance platforms",
    ],
    without: [
      "Filers with balance-due returns hit a dead end inside your product",
      "Preparers refer clients out — and risk losing the relationship",
      "A recurring, high-value revenue stream goes uncaptured",
      "Engagement drops the moment the return is filed",
      "EROs and preparers migrate to platforms that offer more",
    ],
    closing:
      "Community Tax embeds representation into the filing workflow — so balance-due moments convert to revenue instead of drop-off.",
  },
  "law-firms": {
    slug: "law-firms",
    nav: "Law Firms",
    icon: "Scale",
    hook: "Serve clients below your representation threshold with a trusted, professional solution.",
    headline: "Retain More Clients Without Expanding Your Tax Practice",
    body: "Many firms focus on complex, high-value controversy work and can't economically serve lower-balance IRS cases. Community Tax services the clients who fall below your engagement threshold — so attorneys stay focused on high-value matters while the firm preserves the relationship.",
    benefits: [
      "Serve clients below your representation threshold with a trusted, professional solution",
      "Create revenue from matters you would otherwise turn away",
      "Keep prospective clients within your ecosystem for future legal work",
      "Focus attorneys on higher-value matters — audit, fraud, and litigation — while Community Tax manages routine resolution cases",
      "Deliver better client outcomes rather than a referral to nowhere",
    ],
    idealFor: [
      "Tax controversy firms",
      "Tax attorneys",
      "Bankruptcy law firms",
      "Estate planning & probate firms",
      "Business law firms",
    ],
    without: [
      "Smaller-dollar matters are declined with no solution offered",
      "Clients leave the firm seeking help elsewhere",
      "Future legal work is lost when the relationship leaves",
      "Attorney time is spent on poor-fit economics",
      "Revenue opportunities are missed",
    ],
    closing:
      "Community Tax services the cases below your threshold — so attorneys stay on high-value work while the firm keeps the relationship and the future matters that come with it.",
  },
  "financial-advisors": {
    slug: "financial-advisors",
    nav: "Financial Advisors",
    icon: "LineChart",
    hook: "Protect client assets from IRS action by resolving levies and garnishments before they draw down the plan.",
    headline: "Protect the Wealth Plan You Built From IRS Action",
    body: "Financial advisors regularly encounter clients whose tax debt quietly undermines a carefully built wealth plan. Community Tax resolves it — and you remain the lead advisor throughout.",
    benefits: [
      "Protect client assets from IRS action by resolving levies and garnishments before they draw down the plan",
      "Strengthen long-term client trust as the advisor who connected them with help for their hardest problem",
      "Deliver truly holistic advice across tax compliance and IRS issues, not just investments",
      "Add a new service line with no overhead through a simple referral, with all communication and representation handled for you",
    ],
    idealFor: [
      "RIAs and fee-only advisors",
      "Wealth management firms",
      "Broker-dealers & insurance producers",
    ],
    without: [
      "IRS levies and garnishments erode the wealth plan you built",
      "Managed assets are drawn down to satisfy the debt, shrinking AUM",
      "The client sees you as unable to help with their most urgent problem",
      "They find tax help elsewhere, giving another advisor a foothold",
      "Trust — and the relationship — transfers to a competitor",
    ],
    closing:
      "Community Tax resolves what your clients can't handle alone — as a referral or a white-labeled extension of your team — while you stay firmly in the lead advisor role.",
  },
};

export const SEGMENT_LIST = Object.values(SEGMENTS);
